import { useParams } from 'react-router-dom';

export interface ClinicSiteContext {
  id: string;
  physicianId: string;
  hostname: string;
  clinicName: string;
  available: boolean;
  fallbackUrl: string;
}
let currentSite: ClinicSiteContext | null = null;
export const getClinicSite = () => currentSite;
export const setClinicSite = (site: ClinicSiteContext | null) => { currentSite = site; };

export function dtpPath(physicianId: string | undefined, suffix = '') {
  if (currentSite && currentSite.physicianId === physicianId) {
    // Existing DTP /portal links refer specifically to membership management.
    if (/^\/portal(?:[?#]|$)/.test(suffix)) return `/portal/membership${suffix.slice(7)}`;
    return suffix || '/';
  }
  return `/dtp/${physicianId}${suffix}`;
}

/** Keep legacy /portal membership links intact while giving every clinic a home. */
export function patientHomePath(physicianId: string | undefined) {
  return currentSite?.physicianId === physicianId ? '/portal' : dtpPath(physicianId, '/home');
}

/** Only resume account routes belonging to the clinic that handled sign-in. */
export function patientSignInDestination(physicianId: string | undefined, requested: unknown) {
  const home = patientHomePath(physicianId);
  if (typeof requested !== 'string') return home;
  const pathname = requested.split(/[?#]/)[0];
  const orders = dtpPath(physicianId, '/orders');
  const accountPaths = [home, orders, dtpPath(physicianId, '/account')];
  const confirmation = pathname.startsWith(`${orders}/`) && /^[^/]+\/confirmation$/.test(pathname.slice(orders.length + 1));
  return accountPaths.includes(pathname) || confirmation ? requested : home;
}
export function useDtpParams<T extends Record<string, string | undefined> = Record<string, string | undefined>>() {
  const params = useParams<T>();
  return { ...params, physicianId: currentSite?.physicianId || (params as Record<string, string | undefined>).physicianId };
}
